import { useRouter } from 'next/router'
import { useEffect } from 'react'
import posthog from 'posthog-js'

export function PostHogPageView() {
  const { asPath, locale } = useRouter()

  // Track pageviews
  useEffect(() => {
    if (asPath && posthog) {
      const url = `${window.origin}/${locale}${asPath}`
      posthog.capture('$pageview', {
        $current_url: url,
      })
    }
  }, [asPath, locale])

  return null
}
